module.exports = __webpack_public_path__ + "img/970x250_layout_2.830a2550.svg";